import { render, staticRenderFns } from "./Report3.vue?vue&type=template&id=652587fa&scoped=true&"
import script from "./Report3.vue?vue&type=script&lang=js&"
export * from "./Report3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652587fa",
  null
  
)

export default component.exports